import { GAME_LIST_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { Game } from 'core/models/Game'

const intialState: { games: Game[], count: number, currentPage: number, isLoading: boolean } = {
  games: [],
  isLoading: false,
  count: 0,
  currentPage: 0
}

interface ActionType extends Action {
  payload: {
    games: Game[];
    count: number;
    currentPage: number;
  }
}

export default function gameListReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case GAME_LIST_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case GAME_LIST_ACTION.SUCCESS:
      const { games, count, currentPage } = action.payload;
      return { ...state, games, count, currentPage, isLoading: false }

    case GAME_LIST_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}